export default "__VITE_PUBLIC_ASSET__74449897__"